// --------- Ordenación de columnas pulsadas
  export function sortByColumn(array: Array<any>, fieldName: string, direction: string, isNumericIn: any): Array<any> {

    console.log('--> Entrando en sortByColumn:');
    // console.log(fieldName);
    // console.log(direction);
    // console.log(isNumericIn);
    // console.log(array);

    let isNumeric = false;

    // NOTA: a veces el campo que indica si es numérico viene como una cadena de caracteres
    // (al ser pasado como un evento desde html lo maneja como string y no como boolean).
    // Por esa razón hay que hacer siempre antes la siguiente asignación por seguridad.
    if (isNumericIn.toString().toUpperCase() === 'TRUE') {
      console.log('-> Es una búsqueda de un campo numérico.')
      isNumeric = true;
    }

    // Have to handle deep paths
    let pathValue = function (obj, path) {
        for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
            obj = obj[path[i]];
        }
        return obj;
    };

    let sortFunc = function (field, rev, primer) {
        // Return the required a,b function
        return function (a, b) {
            // Reset a, b to the field
            a = primer(pathValue(a, field)), b = primer(pathValue(b, field));
            // Do actual sorting, reverse as needed
            return ((a < b) ? -1 : ((a > b) ? 1 : 0)) * (rev ? -1 : 1);
        }
    };

    let primer = isNumeric ?
        function (a) {
            let retValue = parseFloat(String(a).replace(/[^0-9.-]+/g, ''));
            return isNaN(retValue) ? 0.0 : retValue;
        } :
        function (a) { return String(a).toUpperCase(); };

    // this._isSorting = true;
    // this._start = new Date().getTime();
     return array.sort(sortFunc(fieldName, direction === 'desc', primer));
    // this._end = new Date().getTime();
    // var time = this._end - this._start;
    // console.log('Sort time: ' + time);
    // this._isSorting = false;
  }